export default __webpack_public_path__ + "static/media/Detail-documentation.23d951f3.md";